import { useState } from 'react';

// Aceternity UI Spotlight Card - Professional spotlight effect
const SpotlightCard = ({ children, className = '' }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <div
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      className={`relative overflow-hidden rounded-2xl transition-all duration-300 ${className}`}
    >
      {/* Spotlight gradient background */}
      {isHovering && (
        <div
          className="pointer-events-none absolute -inset-px rounded-2xl transition duration-300"
          style={{
            background: `radial-gradient(circle 800px at ${position.x}px ${position.y}px, rgba(59, 130, 246, 0.15), transparent 80%)`,
            opacity: 1,
          }}
        />
      )}

      {/* Border glow effect */}
      <div
        className={`absolute -inset-px rounded-2xl transition duration-300 pointer-events-none ${
          isHovering
            ? 'bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20'
            : 'bg-gradient-to-r from-transparent via-transparent to-transparent'
        }`}
      />

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default SpotlightCard;
